import Markdown from 'markdown-to-jsx'
import { ElenchiManager } from '@lucan/base-ui'

export default function ConfigManager(props) {
  const { elenchiConfig, render, ...restProps } = props

  return (
    <ElenchiManager
      elenchi={elenchiConfig}
      render={el =>
        <ConfigManagerInterno
          oggettiConfig={elenchiConfig.map(chiaveElenco => el(chiaveElenco))}
          render={render}
          {...restProps}
        />
      }
    />
  )
}



function ConfigManagerInterno(props) {
  const { oggettiConfig, render, children } = props

  function val(chiave, sostituzioni = {}, nullable = false) {
    let valoreTrovato = null
    oggettiConfig.some(config => {
      const valore = config[chiave]
      if (valore !== null && valore !== undefined) {
        valoreTrovato = valore
        return true
      }
      return false
    })
    if (typeof valoreTrovato === 'string') {
      Object.entries(sostituzioni).forEach(([chiaveSost, valoreSost]) => {
        valoreTrovato = valoreTrovato.replaceAll(`{${chiaveSost}}`, valoreSost)
      })
    }
    if (valoreTrovato === null && !nullable) console.warn('chiave config non trovata', chiave)
    return valoreTrovato
  }

  function obj(chiave, prop, sostituzioni = {}) {
    return { [prop]: val(chiave, sostituzioni), className: chiave }
  }

  function txt(chiave, sostituzioni) {
    const valore = val(chiave, sostituzioni)
    if (valore === null) return null
    return <Markdown title={chiave} options={{ wrapper: 'span' }}>{valore}</Markdown>
  }
  if(typeof children === "function" ){
    return children({ val, txt, obj })
  }
  return render({ val, txt, obj })
}